// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__11oKd","name":"ConsentHeader_name__3V9hi","birthday":"ConsentHeader_birthday__3qr7-","skeleton":"ConsentHeader_skeleton__dBt5m"};